import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import axios from "axios";
import "./Admin.css";

const Reports = () => {

    const [data, setData] = useState([]);

    const downloadExcel = async () => {
      try {
        //const res = await axios.get("http://localhost:8000/api/export-excel", {
          const res = await axios.get("https://alphabeta4success.com/api/export-excel", {
          responseType: "blob",
        });
    
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
    
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
    
        document.body.appendChild(link);
        link.click();
    
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Download failed:", err);
      }
    };

  const navigate = useNavigate();
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) {
      navigate("/Signin"); // redirect if not logged in
    }
  }, [navigate]);
  const userName = sessionStorage.getItem("username");
  const userType = sessionStorage.getItem("userType"); 
  const userImage = "https://broken-link.com/avatar.png";

  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [istClock, setIstClock] = useState("");

  const fetchUsers = async () => {
    try {
      //const res = await axios.get("http://localhost:8000/api/users");
      const res = await axios.get("https://alphabeta4success.com/api/users");
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const searchUsers = async () => {
    if (searchQuery.trim() === "") {
      fetchUsers();
      return;
    }
    try {
      //const res = await axios.get(`http://localhost:8000/api/search/${searchQuery}`);
      const res = await axios.get(`https://alphabeta4success.com/api/search/${searchQuery}`);
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {

    const clockInterval = setInterval(() => {
      const ist = new Date().toLocaleTimeString("en-IN", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      setIstClock(ist);
    }, 1000);

    return () => {
      clearInterval(clockInterval);
    };
  }, []);

  return (
    <div>
      <section id="sidebar">
        <Link to="#" className="brand">
          <img src="/Assets/images/AB4S_logo.png" alt="AB4S" className="sidebar-logo" />
        </Link>
        {userType === "Admin" && (
        <> 
        <ul className="side-menu top">
          <li><Link to="/AdminDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
          <li><a href="https://alphabeta4success.com/action.html" target="_blank" rel="noopener noreferrer"><i className="bx bx-video"></i><span className="text">Classroom</span></a></li>
          <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
          <li><Link to="/Allocation"><i className="bx bxs-book-content"></i><span className="text">Allocation</span></Link></li>
          <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
          <li><Link to="/UserManagement"><i className="bx bxs-group"></i><span className="text">User Management</span></Link></li>
          <li><Link to="/Contacts"><i className="bx bx-id-card"></i><span className="text">Contacts</span></Link></li>
          <li className="active"><Link to="/Reports"><i className="bx bx-download"></i><span className="text">Reports</span></Link></li>
          <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
          <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
        </ul>
        <ul className="side-menu">
          <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
          <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
        </ul>
        </>
        )}

        {userType === "Tutor" && (
        <> 
          <ul className="side-menu top">
            <li><Link to="/TutorDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
            <li><a href="https://alphabeta4success.com/action.html" target="_blank" rel="noopener noreferrer"><i className="bx bx-video"></i><span className="text">Classroom</span></a></li>
            <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
            <li className="active"><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
            <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
            <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
           </ul>
           <ul className="side-menu">
            <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
            <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
           </ul>
        </>
        )}
      </section>

      <section id="content">
        <nav>
          <i className="bx bx-menu"></i>
          <h3><span className="highlight-purple">Happy Learning <i className='bx bxs-smile'></i></span></h3>
          <form onSubmit={(e) => { e.preventDefault(); searchUsers(); }}>
            <div className="form-input">
              <input type="search" placeholder="Search by username..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
              <button type="submit" className="search-btn" onClick={searchUsers}>
                <i className="bx bx-search"></i>
              </button>
            </div>
          </form>
          <input type="checkbox" id="switch-mode" hidden />
          <label htmlFor="switch-mode" className="switch-mode"></label>
          <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 30 }}>
            <span style={{ marginRight: "6px", fontWeight: 600 }}>
              ⏰ -  {istClock} : IST
            </span>
            <span style={{ marginLeft: 8 }}><h3>Welcome, {userName}</h3></span>
            <Avatar name={userName} src={userImage} size={30} className="avatar" />
          </div>
        </nav>

        <main>
          <div className="head-title">
            <h2>Reports</h2>
          </div>
          <table>
            <tbody>
                <tr>
                    <td>
                    <div className="allocation-form p-4 max-w-2xl mx-auto">
                        <table>
                        <tbody>
                            <tr>
                            <td>
                            <div>
                                <h3>Report: download Excel file</h3>
                                <button onClick={downloadExcel}>Download</button>
                                </div>
                            </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </td>
                </tr>
            </tbody>
          </table>
        </main>
      </section>
    </div>
  );
};

export default Reports;
